export default __webpack_public_path__ + "static/media/004-instagram.15184e39.svg";